import React from 'react';
import {
    Button,
    TextField,
    Grid,
    Typography,
    Container,
    Avatar,
    IconButton,
    Link
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';

import EnderecoForm from '../../../components/EnderecoForm';
import ContatoForm from '../../../components/ContatoForm';

const useStyles = makeStyles((theme) => ({
    input: {
        display: 'none',
    },
    paper: {
        marginTop: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    small: {
        width: theme.spacing(3),
        height: theme.spacing(3),
    },
    avatarlarge: {
        width: theme.spacing(16),
        height: theme.spacing(16),
    },
    iconlarge: {
        width: theme.spacing(16),
        height: theme.spacing(16),
    },
    spacingLink: {
        marginRight: theme.spacing(2)
    },
}));

export default function MeusDadosForm(props) {
    const classes = useStyles();
    const user = props.user
    const fotoPerfil = props.uriFotoPerfil

    const [firtName, setFirtName] = React.useState(user.first_name);
    const [lastName, setLastName] = React.useState(user.last_name);
    const [isCnpj, setIsCnpj] = React.useState(false);

    const [selectedFile, setSelectedFile] = React.useState()
    const [preview, setPreview] = React.useState()

    const onSelectFile = e => {
        if (!e.target.files || e.target.files.length === 0) {
            return
        }
        // I've kept this example simple by using the first image instead of multiple
        setSelectedFile(e.target.files[0])
    }

    function cancelar() {
        setSelectedFile(undefined)
    }

    async function salvar() {
        await props.submitPhoto(selectedFile)
        window.location.reload();
    }

    // create a preview as a side effect, whenever selected file is changed
    React.useEffect(() => {
        if (!selectedFile) {
            setPreview(undefined)
            return
        }

        const objectUrl = URL.createObjectURL(selectedFile)
        setPreview(objectUrl)

        // free memory when ever this component is unmounted
        return () => URL.revokeObjectURL(objectUrl)
    }, [selectedFile])

    React.useEffect(() => {
        if (user.document.length > 14) {
            setIsCnpj(true);
        } else {
            setIsCnpj(false);
        }
    }, [user]);

    onsubmit = (event) => {
        event.preventDefault()
        props.onSubmit(firtName, lastName)
    }

    return (
        <Container component="main" maxWidth="sm">
            <div className={classes.paper}>
                <form className={classes.form}>
                    <Grid container spacing={2}>

                        <Grid
                            item xs={12}
                            container
                            direction="column"
                            justify="center"
                            alignItems="center"
                        >
                            <input
                                accept="image/jpeg, image/png"
                                className={classes.input}
                                id="icon-button-file"
                                type="file"
                                onChange={onSelectFile}
                            />
                            <label htmlFor="icon-button-file">
                                <IconButton
                                    color="primary"
                                    aria-label="upload picture"
                                    component="span"

                                >
                                    <Avatar className={classes.avatarlarge} >
                                        {preview || fotoPerfil !== '' ?
                                            <img src={preview ? preview : fotoPerfil} className={classes.iconlarge} />
                                            :
                                            <AccountCircleIcon className={classes.iconlarge} />
                                        }
                                    </Avatar>
                                </IconButton>
                            </label>
                            {selectedFile &&
                                <Grid
                                    item xs={12}
                                    container
                                    direction="row"
                                    justify="center"
                                    alignItems="center"
                                >
                                    <Link
                                        href="#"
                                        onClick={() => cancelar()}
                                        className={classes.spacingLink}
                                    >
                                        Cancelar
                                </Link>
                                    <Link href="#" onClick={() => salvar()}>
                                        Salvar
                                </Link>
                                </Grid>
                            }

                        </Grid>
                        {isCnpj ?
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    id="cnpj"
                                    label="CNPJ"
                                    name="cnpj"
                                    type="text"
                                    autoFocus
                                    disabled
                                    value={user.document}
                                />
                            </Grid>
                            :
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    id="cpf"
                                    label="CPF"
                                    name="cpf"
                                    type="text"
                                    autoFocus
                                    disabled
                                    value={user.document}
                                />
                            </Grid>
                        }
                        {isCnpj ?
                            <Grid item xs={12}>
                                <TextField
                                    autoComplete="fname"
                                    name="firstName"
                                    variant="outlined"
                                    required
                                    fullWidth
                                    id="firstName"
                                    label="Nome da empresa"
                                    onChange={(e) => setFirtName(e.target.value)}
                                    value={firtName}
                                />
                            </Grid>
                            :
                            <>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        autoComplete="fname"
                                        name="firstName"
                                        variant="outlined"
                                        required
                                        fullWidth
                                        id="firstName"
                                        label="Primeiro Nome"
                                        onChange={(e) => setFirtName(e.target.value)}
                                        value={firtName}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        variant="outlined"
                                        required
                                        fullWidth
                                        id="lastName"
                                        label="Ultimo Nome"
                                        name="lastName"
                                        autoComplete="lname"
                                        onChange={(e) => setLastName(e.target.value)}
                                        value={lastName}
                                    />
                                </Grid>
                            </>
                        }

                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="email"
                                label="E-mail"
                                name="email"
                                type="email"
                                autoComplete="email"
                                value={user.email}
                                disabled
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Typography className={classes.subtite} variant="subtitle1">
                                Localização
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <EnderecoForm />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography className={classes.subtite} variant="subtitle1">
                                Contato
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <ContatoForm />
                        </Grid>

                        <Grid item xs={12}>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                            >
                                Alterar
                            </Button>
                        </Grid>

                    </Grid>

                </form>
            </div>
        </Container >
    );
}